import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "us-east-2_498t02bPn",
  ClientId: "79tsu02jp4u5ndtddv2avcqjmn"
}

export default new CognitoUserPool(poolData);